export default function CommentCell({ text, className = "" }) {
  if (!text) {
    return <span className="text-gray-400">N/A</span>;
  }

  return (
    <div
      className={`max-h-28 overflow-y-auto overflow-x-hidden break-words text-base leading-relaxed text-gray-700 pr-1 ${className}`}
      title={typeof text === "string" && text.length > 80 ? text : undefined}
    >
      {text}
    </div>
  );
}
